import React from "react";
import content from "../content";

const LOGO =
    "https://static.wixstatic.com/media/913191_d541bffa8fc14b0783211e8bb135687e~mv2.png/v1/fill/w_153,h_155,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/logo%20300px%20%2B%20texte%20%2B%20marron.png";

export const Footer = () => {
    const { brand, contact, footer, nav } = content;
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#2C1E16] text-[#F9F8F6] px-6 sm:px-12 lg:px-24 pt-20 pb-10"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-4">
                            <img src={LOGO} alt={brand.name} className="h-14 w-14 bg-[#F9F8F6] p-1" />
                            <div>
                                <p className="font-brand text-2xl sm:text-3xl">{brand.name}</p>
                                <p className="text-xs uppercase tracking-[0.3em] text-[#D2B48C] mt-1">{footer.tagline}</p>
                            </div>
                        </div>
                        <p className="mt-6 text-sm text-white/70 leading-relaxed max-w-md">
                            {footer.description}
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="text-xs uppercase tracking-[0.3em] text-[#D2B48C] mb-5">{footer.sectionVisitTitle}</p>
                        <ul className="space-y-3 text-sm">
                            {nav.links.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-link-${l.href.replace("#", "")}`}
                                        className="hover:text-[#D2B48C] transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-[#D2B48C] mb-5">{footer.sectionContactTitle}</p>
                        <address className="not-italic text-sm space-y-3 text-white/85">
                            <p>{contact.addressLine1}<br />{contact.addressLine2}</p>
                            <p>
                                <a href={`tel:${contact.phoneIntl}`} className="hover:text-[#D2B48C] transition-colors">{contact.phone}</a>
                            </p>
                            <p>
                                <a href={`mailto:${contact.email}`} className="hover:text-[#D2B48C] transition-colors break-all">
                                    {contact.email}
                                </a>
                            </p>
                        </address>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-6 text-xs text-white/50">
                    <p>© {new Date().getFullYear()} {brand.name} — {footer.copyright}</p>

                    <a
                        href="https://www.maitresrestaurateurs.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-maitre-restaurateur"
                        aria-label="Maître Restaurateur — En savoir plus"
                        title="Maître Restaurateur — En savoir plus"
                        className="group inline-flex items-center gap-3 opacity-70 hover:opacity-100 transition-opacity"
                    >
                        <img
                            src="https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/1rd2ykpt_Logo%20MR.jpg"
                            alt="Association Française des Maîtres Restaurateurs"
                            className="h-12 w-auto bg-white p-1 rounded-sm shadow-sm"
                        />
                    </a>

                    <p className="font-serif italic text-[#D2B48C]">{footer.quote}</p>
                </div>
            </div>
        </footer>
    );
};
